import { render, staticRenderFns } from "./AxExpStep.vue?vue&type=template&id=3dca74c3&scoped=true&"
import script from "./AxExpStep.vue?vue&type=script&lang=js&"
export * from "./AxExpStep.vue?vue&type=script&lang=js&"
import style0 from "./AxExpStep.vue?vue&type=style&index=0&id=3dca74c3&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3dca74c3",
  null
  
)

export default component.exports